import { render, staticRenderFns } from "./TelcoView.vue?vue&type=template&id=54868ef2"
import script from "./TelcoView.vue?vue&type=script&lang=js"
export * from "./TelcoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports